import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import ZenModal from "../../../ZenModal";
import liracrypt from "../../../Liracrypt/liracrypt";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import { useSelector } from "react-redux";
import noImg from '../../../../assets/static/noImg.jpeg';
import queryString from "query-string";
import { useLocation } from 'react-router-dom';
const ZenPieBar = (props) => {
  const urlCode = useSelector(state => state.urlCode);
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);
  const [chartConfig, setChartConfig] = useState();
  const [chartData, setChartData] = useState();
  const [zenModal, setZenModal] = useState();

  const [modal, setModal] = useState({
    type: "route",
    data: undefined,
    show: false,
    loading: false,
  });

  const toggleModal = ({
    show = false,
    data = undefined,
    type = '',
    loading = false,
  }) => {
    setModal({ show, data, type, loading });
  };
  /* CHART CREATION */
  const createChart = (args, chartContainer) => {
    if (args.data) {
      chartContainer.width = am4core.percent(95);
      chartContainer.height = am4core.percent(100);
      chartContainer.layout = "horizontal";




      /**
       * Pie chart
       */

      // Create chart instance
      var pieChart = chartContainer.createChild(am4charts.PieChart);
      pieChart.data = args.data;
      pieChart.innerRadius = am4core.percent(50);
      pieChart.padding(args.config.pie.chartDiv.padding[0], args.config.pie.chartDiv.padding[1], args.config.pie.chartDiv.padding[2], args.config.pie.chartDiv.padding[3]);;
      pieChart.margin(args.config.pie.chartDiv.margin[0], args.config.pie.chartDiv.margin[1], args.config.pie.chartDiv.margin[2], args.config.pie.chartDiv.margin[3]);


      if (args.config.pie.title.enable === true) {
        var title = pieChart.titles.create();
        title.text = args.config.pie.title.val;
        title.fontSize = args.config.pie.title.fontSize;
        title.margin(args.config.pie.title.margin[0], args.config.pie.title.margin[1], args.config.pie.title.margin[2], args.config.pie.title.margin[3]);
        title.padding(args.config.pie.title.padding[0], args.config.pie.title.padding[1], args.config.pie.title.padding[2], args.config.pie.title.padding[3]);

        title.fontWeight = args.config.pie.title.fontWeight;
        title.fill = args.config.pie.title.color;
      }

      var pieSeries = pieChart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = args.config.pie.pieSeries.dataFields.value;

      pieSeries.dataFields.category =
        args.config.pie.pieSeries.dataFields.category;
      pieSeries.name = args.config.pie.pieSeries.name;

      pieSeries.slices.template.clickable = true;
      pieSeries.slices.template.tooltipText =
        args.config.pie.pieSeries.tooltipText;
      // console.log(args.config.pie.pieSeries)
      // console.log(args.config.pie.pieSeries.autoFillColor)
      if (args.config.pie.pieSeries.dataContainsColorKey === true) {
        // console.log("AUTOFILLLLLLLLLLLLLLLL: FALSE")
        pieSeries.slices.template.propertyFields.fill = "color";
      } else {
        var listColColors = args.config.pie.pieSeries.color;
        pieChart.colors.list = [];
        for (var i = 0; i < listColColors.length; i++) {
          pieChart.colors.list.push(am4core.color(listColColors[i]));
        }

        pieSeries.slices.template.adapter.add("fill", (fill, target) => {
          return target.dataItem
            ? pieChart.colors.getIndex(target.dataItem.index)
            : fill;
        });
      }

      pieSeries.slices.template.fillOpacity =
        args.config.pie.pieSeries.fillOpacity;
      pieSeries.slices.template.strokeOpacity =
        args.config.pie.pieSeries.strokeOpacity;
      pieSeries.slices.template.strokeWidth =
        args.config.pie.pieSeries.strokeWidth;

      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;


      if (args.config.pie.valueLabel.enable === true) {
        pieSeries.ticks.template.disabled = true;
        pieSeries.labels.template.fontSize = args.config.pie.valueLabel.fontSize;
        pieSeries.labels.template.fill = args.config.pie.valueLabel.color;
        // pieSeries.labels.template.text =  args.config.pie.valueLabel.val;
        pieSeries.alignLabels = args.config.pie.valueLabel.alignLabels;
        pieSeries.labels.template.radius = am4core.percent(args.config.pie.valueLabel.radius);
        // var valueLabel = pieSeries.bullets.push(new am4charts.LabelBullet());
        // valueLabel.label.text = args.config.pie.valueLabel.val;
      }
      else {
        pieSeries.labels.template.disabled = true;
        pieSeries.ticks.template.disabled = true;
      }




      // Set up labels
      var labelCenterVal = pieChart.seriesContainer.createChild(am4core.Label);
      labelCenterVal.text = "";
      labelCenterVal.horizontalCenter = args.config.pie.chartProp.centralLabel.horizontalCenter;
      labelCenterVal.fontSize = args.config.pie.chartProp.centralLabel.fontSize;
      labelCenterVal.fontWeight = args.config.pie.chartProp.centralLabel.fontWeight;
      labelCenterVal.dy = args.config.pie.chartProp.centralLabel.dy;
      labelCenterVal.dx = args.config.pie.chartProp.centralLabel.dx;


      var labelSelectedSlice = pieChart.seriesContainer.createChild(am4core.Label);
      labelSelectedSlice.text = "";
      labelSelectedSlice.horizontalCenter = args.config.pie.chartProp.selectedSliceLabel.horizontalCenter;
      labelSelectedSlice.fontSize = args.config.pie.chartProp.selectedSliceLabel.fontSize;
      labelSelectedSlice.fontWeight = args.config.pie.chartProp.selectedSliceLabel.fontWeight;
      labelSelectedSlice.dx = args.config.pie.chartProp.selectedSliceLabel.dx;
      labelSelectedSlice.dy = args.config.pie.chartProp.selectedSliceLabel.dy;


      // Auto-select first slice on load
      pieChart.events.on("ready", function (ev) {
        pieSeries.slices.getIndex(0).isActive = true;
      });

      // Set up toggling events
      pieSeries.slices.template.events.on("toggled", function (ev) {
        if (ev.target.isActive) {
          // Untoggle other slices
          pieSeries.slices.each(function (slice) {
            if (slice != ev.target) {
              slice.isActive = false;
            }
          });

          // Update column chart
          columnSeries.appeared = false;
          columnChart.data = ev.target.dataItem.dataContext.breakdown;
          columnSeries.fill = ev.target.fill;
          columnSeries.reinit();

          // Update labels
          labelCenterVal.text = pieChart.numberFormatter.format(
            ev.target.dataItem.values.value.percent,
            "#.'%'"
          );
          labelCenterVal.fill = ev.target.fill;
          labelSelectedSlice.text = ev.target.dataItem.category;
          // console.log(args.config.pie.chartProp.selectedSliceLabelCol)
          labelSelectedSlice.fill = am4core.color(args.config.pie.chartProp.selectedSliceLabel.color);
        }
      });

      var columnChart = chartContainer.createChild(am4charts.XYChart);

      columnChart.padding(args.config.bar.chartDiv.padding[0], args.config.bar.chartDiv.padding[1], args.config.bar.chartDiv.padding[2], args.config.bar.chartDiv.padding[3]);;
      columnChart.margin(args.config.bar.chartDiv.margin[0], args.config.bar.chartDiv.margin[1], args.config.bar.chartDiv.margin[2], args.config.bar.chartDiv.margin[3]);

      if (args.config.bar.title.enable === true) {
        var title = columnChart.titles.create();
        title.text = args.config.bar.title.val;
        title.fontSize = args.config.bar.title.fontSize;
        title.margin(args.config.bar.title.margin[0], args.config.bar.title.margin[1], args.config.bar.title.margin[2], args.config.bar.title.margin[3]);
        title.padding(args.config.bar.title.padding[0], args.config.bar.title.padding[1], args.config.bar.title.padding[2], args.config.bar.title.padding[3]);
        title.fontWeight = args.config.bar.title.fontWeight;
        title.fill = args.config.bar.title.color;
      }


      // Create axes
      // var categoryAxis = columnChart.yAxes.push(new am4charts.CategoryAxis());
      // categoryAxis.dataFields.category =
      //   args.config.pie.pieSeries.dataFields.category;
      // categoryAxis.renderer.grid.template.location = 0;
      // categoryAxis.renderer.inversed = true;
      var categoryAxis = columnChart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category =
        args.config.pie.pieSeries.dataFields.category;
      categoryAxis.renderer.line.strokeOpacity =
        args.config.bar.categoryAxis.line.strokeOpacity;
      categoryAxis.renderer.line.strokeWidth =
        args.config.bar.categoryAxis.line.strokeWidth;
      categoryAxis.renderer.line.stroke = am4core.color(
        args.config.bar.categoryAxis.line.stroke
      );
      categoryAxis.renderer.labels.template.fontSize =
        args.config.bar.categoryAxis.label.fontSize;
      categoryAxis.renderer.labels.template.fill =
        args.config.bar.categoryAxis.label.color;
      categoryAxis.renderer.grid.template.strokeOpacity =
        args.config.bar.categoryAxis.grid.strokeOpacity;
      categoryAxis.renderer.grid.template.stroke = am4core.color(
        args.config.bar.categoryAxis.grid.stroke
      );
      categoryAxis.renderer.grid.template.strokeWidth =
        args.config.bar.categoryAxis.grid.strokeWidth;
      categoryAxis.renderer.minGridDistance =
        args.config.bar.categoryAxis.grid.minGridDistance;
      categoryAxis.renderer.labels.template.dx =
        args.config.bar.categoryAxis.label.dx;
      categoryAxis.renderer.labels.template.dy =
        args.config.bar.categoryAxis.label.dy;
      if (args.config.bar.categoryAxis.label.wrap === true) {
        categoryAxis.renderer.labels.template.wrap = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.bar.categoryAxis.label.maxWidth;
      }
      if (args.config.bar.categoryAxis.label.truncate === true) {
        categoryAxis.renderer.labels.template.truncate = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.bar.categoryAxis.label.maxWidth;
      }

      categoryAxis.events.on("sizechanged", function (ev) {
        var axis = ev.target;
        if (args.config.bar.categoryAxis.label.orientation === "ang") {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        } else if (args.config.bar.categoryAxis.label.orientation === "hor") {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        } else if (args.config.bar.categoryAxis.label.orientation === "ver") {
          axis.renderer.labels.template.rotation = -90;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });



      var valueAxis = columnChart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.line.strokeOpacity =
        args.config.bar.valueAxis.line.strokeOpacity;
      valueAxis.renderer.line.strokeWidth =
        args.config.bar.valueAxis.line.strokeWidth;
      valueAxis.renderer.line.stroke = am4core.color(
        args.config.bar.valueAxis.line.stroke
      );
      if (args.config.bar.valueAxis.enable === false) {
        valueAxis.renderer.labels.template.disabled = true;
      } else {
        valueAxis.renderer.labels.template.fill = args.config.bar.valueAxis.color;
        valueAxis.renderer.labels.template.fontSize =
          args.config.bar.valueAxis.fontSize;
      }

      if (args.config.bar.valueAxis.minVal === "auto") {
        valueAxis.min = 0;
      }
      valueAxis.renderer.grid.template.strokeOpacity =
        args.config.bar.valueAxis.grid.strokeOpacity;
      valueAxis.renderer.grid.template.stroke = am4core.color(
        args.config.bar.valueAxis.grid.stroke
      );
      valueAxis.renderer.grid.template.strokeWidth =
        args.config.bar.valueAxis.grid.strokeWidth;
      // var valueAxis = columnChart.xAxes.push(new am4charts.ValueAxis());

      // Create series
      // var columnSeries = columnChart.series.push(new am4charts.ColumnSeries());
      // columnSeries.dataFields.valueX =  args.config.pie.pieSeries.dataFields.value;;
      // columnSeries.dataFields.categoryY =  args.config.pie.pieSeries.dataFields.category;
      // columnSeries.columns.template.strokeWidth = 0;

      let columnSeries = columnChart.series.push(new am4charts.ColumnSeries());
      columnSeries.xAxis = valueAxis;
      columnSeries.dataFields.valueX =
        args.config.pie.pieSeries.dataFields.value;
      columnSeries.dataFields.categoryY =
        args.config.pie.pieSeries.dataFields.category;

      columnSeries.dataFields._id = "_id";
      columnSeries.name = args.config.bar.columnSeries.name;
      columnSeries.columns.template.width = am4core.percent(
        args.config.bar.columnSeries.columnWidth
      );
      columnSeries.columns.template.tooltipText =
        args.config.bar.columnSeries.tooltipText;

      columnSeries.columns.template.column.cornerRadius =
        args.config.bar.columnSeries.cornerRadius;
      if (args.config.bar.columnSeries.shadow.enable === true) {
        var shadow = columnSeries.filters.push(new am4core.DropShadowFilter());
        shadow.dx = args.config.bar.columnSeries.shadow.dx;
        shadow.dy = args.config.bar.columnSeries.shadow.dy;
        shadow.blur = args.config.bar.columnSeries.shadow.blur;
        chart.current = columnChart;
      }
      var colSeriesLabel = columnSeries.bullets.push(
        new am4charts.LabelBullet()
      );
      colSeriesLabel.label.fill = args.config.bar.columnSeries.label.fill

      colSeriesLabel.label.text = args.config.bar.columnSeries.label.val;
      colSeriesLabel.label.fontSize =
        args.config.bar.columnSeries.label.fontSize;
      colSeriesLabel.label.dx = args.config.bar.columnSeries.label.dx;
      colSeriesLabel.label.dy = args.config.bar.columnSeries.label.dy;
    }
  }




  const getApiChartData = (args) => {
    let params = { ...args?.params };
    liracrypt
      .get(props.api, { ...searchParams, ...props.urlData, ...params })
      .then((response) => {
        console.log(response.data.data[props.divId]);
        if (!response.data.data[props.divId]) {
          return console.log("No Data Found");
        };
        if (props.setChartId) {
          props.setChartId(response.data.data[props.divId].meta._id);
        }
        if (props.setChartDataSource) {
          props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
        }
        setChartData(response.data.data[props.divId]);
        // setTimeout(() => {
        //   chart = am4core.create(props.divId, am4charts.XYChart)
        //   createChart({
        //     data: response.data.data[props.divId].data,
        //     config: response.data.data[props.divId].config
        //   },
        //     chart);
        // }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  /* CHART CREATION */
  useEffect(() => {
    let chart = null;
    if (props.api) {
      setChartData(null);
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.XYChart)
      //   createChart({ data: props.data, config: props.config }, chart);
      // }, 500);
    }
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4core.Container);
      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);


  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
    return toggleModal({
      show: true,
      data: zenPopup?.data,
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }


  return (
    <div>
      {chartData?.data ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div id={props.divId} style={chartData?.config.aux.style}></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
    // <div>
    //   <div id={props.divId} style={chartData?.config.aux.style}
    //   ></div>
    //   {/* <ZenModal modal={modal} toggleModal={toggleModal} zenModal={chartData.config.zenModal} /> */}
    // </div>
  );
};

export default ZenPieBar;